module.exports = __webpack_public_path__ + "img/user-default-avatar.7eb64e98.svg";